import { PageLocatorMap } from '../types/PageLocatorMap';

export const verificationDocumentListPage = {
  footer: {
    root: 'verification-document-list-page.footer.root',
  },
  form: {
    getVerificationLink: (index: number): string =>
      `verification-document-list-page.form.verification-link-${index + 1}`,
    h1: 'verification-document-list-page.form.h1',
    h2: 'verification-document-list-page.form.h2',
    root: 'verification-document-list-page.form.root',
  },
} as const satisfies PageLocatorMap;
